import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadPixels, track } from "@/lib/tracking";

// Carica i pixel (se c'è consenso) e invia una page_view a ogni cambio rotta.
export const RouteTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const onConsent = () => loadPixels();
    window.addEventListener("cs-consent", onConsent);
    return () => window.removeEventListener("cs-consent", onConsent);
  }, []);

  useEffect(() => {
    loadPixels();
    track("page_view", { page_path: pathname + search, page_title: document.title });
  }, [pathname, search]);

  return null;
};
